import { Checkbox, Stack } from "@mui/material";
import { type ComponentType, type Ref, forwardRef } from "react";
import { useGroupedVirtualizedSelectContext } from "./context";
import { CheckStatus } from "./logics";

interface IVirutosoHeaderProps<Context> {
  context?: Context;
}

export const virtuosoHeader = <Context,>(Header: ComponentType<IVirutosoHeaderProps<Context>>) =>
  forwardRef(function VirtuosoHeader(props: IVirutosoHeaderProps<Context>, ref?: Ref<HTMLDivElement>) {
    const { hideCheckboxes, slotProps, getAllCheckStatus, addAll, deleteAll } = useGroupedVirtualizedSelectContext();
    const checkStatus = getAllCheckStatus();

    return (
      <Stack
        direction="row"
        {...slotProps?.selectHeader}
        ref={ref}
        sx={{
          alignItems: "center",
        }}
      >
        <Checkbox
          {...slotProps?.selectHeaderCheckbox}
          sx={{ ...(hideCheckboxes && { display: "none" }), ...slotProps?.selectHeaderCheckbox?.sx }}
          checked={checkStatus === CheckStatus.CHECKED}
          indeterminate={checkStatus === CheckStatus.INDETERMINATE}
          onChange={(evt) => (evt.target.checked ? addAll() : deleteAll())}
        />
        <Header {...props} />
      </Stack>
    );
  });
